import { jwtDecode } from '@/helpers/jwt.js'
import { organizationService, userService } from '@/services'

let initialState = {
  Organizations: [
    {
      OrganizationId: null, // number
      OrganizationName: null, // string
      IsAdmin: null // boolean
    }
  ],
  selectedOrganization: {
    OrganizationId: null, // number
    OrganizationName: null, // string
    IsAdmin: null // boolean
  }
}

export default {
  state: () => initialState,
  mutations: {
    SET_ORGANIZATIONS(state, organizations) {
      state.Organizations = organizations
    },
    SET_SELECTED_ORGANIZATION(state, organization) {
      state.selectedOrganization = organization
    },
    ADD_ORGANIZATION(state, organization) {
      state.Organizations.push(organization)
    },
    RESET(state) {
      state.selectedOrganization = initialState.selectedOrganization
      state.Organizations = initialState.Organizations
    }
  },
  actions: {
    async createOrganization({ dispatch }, payload) {
      return new Promise(async (resolve, reject) => {
        await organizationService
          .create(payload)
          .then(() => {
            dispatch('refreshToken') // update entry.state.jwt
            resolve(true)
          })
          .catch(() => {
            reject()
          })
      })
    },
    async renameOrganization({ dispatch }, organization) {
      return new Promise(async (resolve, reject) => {
        await organizationService
          .rename({
            id: organization.id,
            name: organization.name
          })
          .then(() => {
            dispatch('refreshToken')
            resolve(true)
          })
          .catch(() => {
            reject()
          })
      })
    },
    refreshToken({ dispatch }) {
      return new Promise(async (resolve, reject) => {
        await userService
          .refreshToken()
          .then(response => {
            response.jwt && dispatch('setOrganizationByLoginResponse', response) // update organizationData
            resolve(true)
          })
          .catch(() => {
            reject()
          })
      })
    },
    setOrganizationByLoginResponse({ commit }, loginResponse) {
      if (loginResponse.jwt) {
        const organizations =
          JSON.parse(jwtDecode(loginResponse.jwt).Organizations) || []
        commit('SET_ORGANIZATIONS', [])
        if (organizations.length > 0) {
          organizations.sort((a, b) =>
            a?.OrganizationName?.localeCompare(b.OrganizationName)
          )
          organizations.forEach(organization => {
            commit('ADD_ORGANIZATION', organization)
          })
          ;(organizations[0] !== null) | undefined &&
            commit('SET_SELECTED_ORGANIZATION', organizations[0])
        }
      }
    }
  },
  getters: {
    hasOrganizations: state => {
      return state.Organizations.length > 0
    },
    organizations: state => {
      return state.Organizations
    },
    isAdminInAnyOrganization: state => {
      return state?.Organizations?.some(org => org?.IsAdmin)
    },
    organizationsWithAdminPermissions: state => {
      if (
        typeof state.Organizations === 'undefined' ||
        state.Organizations === null
      ) {
        return []
      }
      return state.Organizations.filter(org => org.IsAdmin)
    },
    selectedOrganization: state => {
      if (
        state.selectedOrganization.OrganizationId === null &&
        state.Organizations.length > 0
      ) {
        return state.Organizations[0]
      }
      return state.selectedOrganization
    }
  }
}
